import { Close, HamburgerRedesigned } from '@ecomm/shared-icons'

type HamburgerButtonProps = {
  readonly open: boolean
  readonly onClick: (_: boolean) => void
}

export function HamburgerButton({ open, onClick }: HamburgerButtonProps) {
  return (
    <button
      aria-expanded={open}
      aria-label={open ? 'Close side navigation' : 'Open side navigation'}
      className="h-7 w-7 cursor-pointer border-none bg-transparent px-1 py-0 text-white min-[1126px]:hidden"
      onClick={() => onClick(true)}
    >
      {open ? (
        <Close className="h-7 w-7" />
      ) : (
        <HamburgerRedesigned className="h-7 w-7" />
      )}
    </button>
  )
}
